"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4750],{

/***/ 74303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* reexport safe */ _Icon__WEBPACK_IMPORTED_MODULE_0__.J; }
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88740);


/***/ }),

/***/ 90358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Notice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);






var Notice = function Notice(props) {
  var styles = props.styles,
      children = props.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    css: [textStyle, styles,  true ? "" : 0,  true ? "" : 0],
    children: children
  });
};
var textStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.caption */ .JB.caption, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight.caption3 */ .Nv.caption3, ";padding:0.125rem 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.secondaryColor */ .z.secondaryColor, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 14864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ SelectBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/components/form/Label.tsx
var Label = __webpack_require__(35183);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/form/Select.tsx


var _excluded = ["name", "children", "styles", "validate", "borderStyleKey", "borderColorStyleKey", "fontSizeStyleKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Select = function Select(props) {
  var name = props.name,
      children = props.children,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      validate = props.validate,
      _props$borderStyleKey = props.borderStyleKey,
      borderStyleKey = _props$borderStyleKey === void 0 ? "default" : _props$borderStyleKey,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      _props$fontSizeStyleK = props.fontSizeStyleKey,
      fontSizeStyleKey = _props$fontSizeStyleK === void 0 ? "default" : _props$fontSizeStyleK,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var exBlockStyle = styles.exBlockStyle,
      exSelectStyle = styles.exSelectStyle;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: [blockStyle, exBlockStyle,  true ? "" : 0,  true ? "" : 0],
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("select", _objectSpread(_objectSpread(_objectSpread({
      css: [selectStyle, selectBorderStyle[borderStyleKey], selectBorderColorStyle[borderColorStyleKey], selectFontSizeStyle[fontSizeStyleKey], exSelectStyle,  true ? "" : 0,  true ? "" : 0]
    }, register(name, validate)), rest), {}, {
      children: children
    }))
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;&:after{content:\"\";position:absolute;top:50%;right:", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";width:0.5rem;height:0.5rem;border:0.125rem solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";border-top:0;border-left:0;transform:translateY(-70%) rotate(45deg);}" + ( true ? "" : 0),  true ? "" : 0);
var selectStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.form */.JB.form, ";line-height:", typographyStyle/* lineHeight.body1 */.Nv.body1, ";font-weight:", typographyStyle/* fontWeight.regular */.Ue.regular, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";padding:0.125rem calc(", spaceStyle/* space.atom3x */.D.atom3x, " + 0.5rem) 0 ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";box-sizing:border-box;margin:0;width:100%;height:40px;appearance:none;background-color:#fff;&:focus{outline:none;}" + ( true ? "" : 0),  true ? "" : 0);
var selectBorderBaseStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border:1px solid ", colorStyle/* backgroundColor.primaryLightColor */.Cz.primaryLightColor, ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);
var selectBorderStyle = {
  "default": /*#__PURE__*/(0,emotion_react_browser_esm.css)(selectBorderBaseStyle, ";" + ( true ? "" : 0),  true ? "" : 0),
  noRound: /*#__PURE__*/(0,emotion_react_browser_esm.css)(selectBorderBaseStyle, ";border-radius:0;" + ( true ? "" : 0),  true ? "" : 0)
};
var selectBorderColorStyle = {
  none:  true ? {
    name: "1oscket",
    styles: "border-color:white"
  } : 0,
  primary: /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-color:", colorStyle/* borderColor.primaryDarkColor */.tv.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary: /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-color:", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};
var selectFontSizeStyle = {
  "default": /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.form */.JB.form, ";" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";" + ( true ? "" : 0),  true ? "" : 0)
};
// EXTERNAL MODULE: ./main/javascripts/components/form/InputError.tsx
var InputError = __webpack_require__(44464);
// EXTERNAL MODULE: ./main/javascripts/components/form/Notice.tsx
var Notice = __webpack_require__(90358);
;// CONCATENATED MODULE: ./main/javascripts/components/form/SelectBlock.tsx


function SelectBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectBlock_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var SelectBlock = function SelectBlock(props) {
  var namespace = props.namespace,
      label = props.label,
      select = props.select,
      error = props.error,
      notice = props.notice,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      validate = props.validate,
      defaultValue = props.defaultValue,
      borderStyleKey = props.borderStyleKey,
      fontSizeStyleKey = props.fontSizeStyleKey,
      borderColorStyleKey = props.borderColorStyleKey;
  var exBlockStyle = styles.exBlockStyle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: [SelectBlock_blockStyle, exBlockStyle,  true ? "" : 0,  true ? "" : 0],
    children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* Label */._, SelectBlock_objectSpread({}, label)), notice && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notice/* Notice */.q, {
      children: notice
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select, SelectBlock_objectSpread(SelectBlock_objectSpread({}, select), {}, {
      validate: validate,
      defaultValue: defaultValue,
      borderStyleKey: borderStyleKey,
      borderColorStyleKey: borderColorStyleKey,
      fontSizeStyleKey: fontSizeStyleKey,
      children: select.children
    })), error && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputError/* InputError */.p, {
      namespace: namespace,
      errorMessage: error.message,
      label: select.name
    })]
  });
};
var SelectBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;padding:calc(", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.body1 */.Nv.body1, " - ", typographyStyle/* fontSize.body */.JB.body, ") / 2) ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 79105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ maxWidth; }
/* harmony export */ });
var maxWidth = {
  page1col: "720px",
  page1colWide: "840px",
  page2col: "1024px",
  page2colWide: "1200px"
};

/***/ }),

/***/ 61838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "gn": function() { return /* binding */ isIOS; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }

  return false;
}
function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

/***/ }),

/***/ 75215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G1": function() { return /* binding */ scrollToInputElement; },
/* harmony export */   "X5": function() { return /* binding */ scrollTo; },
/* harmony export */   "kI": function() { return /* binding */ scrollToElement; },
/* harmony export */   "wV": function() { return /* binding */ stopBodyScrolling; },
/* harmony export */   "z9": function() { return /* binding */ calcScrollBarWidth; }
/* harmony export */ });
/* unused harmony exports scrollBottom, scrollTop, documentHeight, height */
/* harmony import */ var dom7__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14602);
/* harmony import */ var main_javascripts_utils_DeviceUtil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61838);


dom7__WEBPACK_IMPORTED_MODULE_0__.$.fn.offset = dom7__WEBPACK_IMPORTED_MODULE_0__/* .offset */ .cv;
dom7__WEBPACK_IMPORTED_MODULE_0__.$.fn.scrollTop = dom7__WEBPACK_IMPORTED_MODULE_0__/* .scrollTop */ .SM;
var scrollToInputDelta = 8;
var scrollBarWidth = 0;
function scrollBottom(id) {
  var element = document.getElementById(id);

  if (element) {
    element.scrollTop = documentHeight(element);
  }
}
function scrollTop(id) {
  var element = document.getElementById(id);

  if (element) {
    element.scrollTop = 0;
  }
}
function documentHeight(el) {
  var body = document.body;
  var element = el || document.documentElement;
  return Math.max(body.scrollHeight, body.offsetHeight, element.clientHeight, element.scrollHeight, element.offsetHeight);
}
function height(id) {
  var element = document.getElementById(id);

  if (element) {
    return Math.max(element.clientHeight, element.scrollHeight, element.offsetHeight);
  }
}

function getScrollElement() {
  var element;

  if ("scrollingElement" in document) {
    element = document.scrollingElement;
  } else if (navigator.userAgent.indexOf("WebKit") !== -1) {
    element = document.body; // Fallback for legacy browsers
  } else {
    element = document.documentElement;
  }

  return element;
}

function scrollTo(to, duration) {
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var element = getScrollElement();

  if (id) {
    element = document.getElementById(id);
  }

  if (duration <= 0 || !element) {
    return;
  }

  var interval = 16;
  var start = element.scrollTop;
  var change = to - start;

  var animateScroll = function animateScroll(currentTime) {
    var elapsedTime = currentTime + interval;
    var position = easeInOut(elapsedTime, start, change, duration);
    setTimeout(function () {
      if (element) {
        if (elapsedTime > duration) {
          element.scrollTop = start + change;
          return;
        }

        element.scrollTop = position;
        animateScroll(elapsedTime);
      }
    }, interval);
  };

  animateScroll(0);
}
function scrollToElement(elm, duration) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var scrollElement = getScrollElement();

  if (elm) {
    var elTop = Number((0,dom7__WEBPACK_IMPORTED_MODULE_0__.$)(elm).offset().top) + Number((0,dom7__WEBPACK_IMPORTED_MODULE_0__.$)(scrollElement).scrollTop()) - offset;
    scrollTo(elTop, duration);
  }
}
function scrollToInputElement(elm, duration) {
  if (elm) {
    if (Number((0,dom7__WEBPACK_IMPORTED_MODULE_0__.$)(elm).offset().top) > scrollToInputDelta || !(0,main_javascripts_utils_DeviceUtil__WEBPACK_IMPORTED_MODULE_1__/* .isIOS */ .gn)()) {
      scrollToElement(elm, duration);
    }
  }
}

function easeInOut(currentTime, start, change, duration) {
  var t = currentTime / (duration / 2);

  if (t < 1) {
    return change / 2 * t * t + start;
  }

  t -= 1;
  return -change / 2 * (t * (t - 2) - 1) + start;
}

function calcScrollBarWidth() {
  var scrollDiv = document.createElement("div");
  Object.assign(scrollDiv.style, {
    width: "100px",
    height: "100px",
    overflow: "scroll",
    position: "absolute",
    top: "-9999px"
  });
  document.body.appendChild(scrollDiv);
  scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth; // console.warn(scrollBarWidth); // Mac:  15

  document.body.removeChild(scrollDiv);
}
var bodyScrollTop = 0;
var bodyScrollTimer = null;
function stopBodyScrolling(bool) {
  var disableDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  clearTimeout(bodyScrollTimer);

  if (bool) {
    bodyScrollTop = window.pageYOffset;
    Object.assign(document.body.style, {
      height: "100%",
      width: "100%",
      position: "fixed",
      top: "-".concat(bodyScrollTop, "px"),
      overflow: "hidden",
      paddingRight: "".concat(scrollBarWidth, "px"),
      boxSizing: "border-box"
    });
  } else {
    bodyScrollTimer = setTimeout(function () {
      var element = getScrollElement();
      var bodyPosition = document.body.style.position;
      Object.assign(document.body.style, {
        height: "",
        width: "",
        position: "",
        top: "",
        overflow: "",
        paddingRight: "",
        boxSizing: ""
      });

      if (bodyPosition === "fixed") {
        element.scrollTop = bodyScrollTop;
      }
    }, disableDuration);
  }
}

/***/ })

}]);